import { createContext } from "react";

import { initialState } from "./reducer";
import type { AsyncConfirmationModalContextType } from "./types";

const noop = () => () => {};

export const AsyncConfirmationModalContext = createContext<AsyncConfirmationModalContextType>({
  activeModal: null,
  state: initialState,
  confirm: () => Promise.resolve("cancel"),
  handleOk: noop,
  handleCancel: noop,
  handleTertiary: noop,
});
